// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPersonAdd_root__12ZRY"};